// @flow
import { createOptimisticAction } from 'Store/utils/createAction';
import { fetchPrice } from './priceTicket.helper';

import PRICE_TICKET_REQUEST from './constants';

export function priceTicketRequest(
  appContext: AppContext,
  location: ProductRouterLocation,
  productId: string,
) {
  return createOptimisticAction(
    PRICE_TICKET_REQUEST,
    {},
    {
      optimist: true,
      promise: fetchPrice(appContext, location, productId),
    },
  );
}
